import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useCallback, useRef, useMemo, useEffect } from "react";
import { ListStatusModal } from "./ListStatusModal";
import { useListingCartContext } from "./ListingCartProvider";
import useListingCart from "./useListingCart";
export const MultiChainListingManager = ({ tokens, onCompleted, }) => {
    const [activeChain, setActiveChain] = useState(0);
    const listFunctions = useRef({});
    const { dispatch } = useListingCartContext();
    const [error, setError] = useState(false);
    const chainGroups = useMemo(() => {
        return tokens.reduce((acc, token) => {
            acc[token.chainId] = acc[token.chainId] || [];
            acc[token.chainId].push(token);
            return acc;
        }, {});
    }, [tokens]);
    const chainEntries = Object.entries(chainGroups);
    const handleListAll = useCallback(async () => {
        var _a, _b;
        dispatch({ type: "SET_TRANSACTION_RUNNING", payload: true });
        for (const [chainId] of chainEntries) {
            const numericChainId = Number(chainId);
            setActiveChain(numericChainId);
            try {
                await ((_b = (_a = listFunctions.current)[numericChainId]) === null || _b === void 0 ? void 0 : _b.call(_a));
            }
            catch (error) {
                console.log("error listing", error);
                dispatch({
                    type: "SET_ERROR",
                    payload: { chainId: Number(chainId), error: error },
                });
                setError(true);
                setActiveChain(0);
                break;
            }
        }
        onCompleted();
        if (!error) {
            dispatch({ type: "SET_FINISHED" });
            setActiveChain(0);
        }
    }, [chainGroups]);
    useEffect(() => {
        if (handleListAll) {
            dispatch({ type: "START_TRANSACTION", payload: handleListAll });
        }
    }, [handleListAll]);
    const chainTokens = useMemo(() => Object.entries(chainGroups).map(([chainId, chainTokens]) => (_jsx(ChainListingCart, { chainId: Number(chainId), tokens: chainTokens, registerLister: (fn) => {
            listFunctions.current[Number(chainId)] = fn;
        } }, chainId))), [chainGroups, activeChain]);
    return (_jsxs(_Fragment, { children: [_jsx(ListStatusModal, { activeChain: activeChain, chainEntries: chainEntries }), chainTokens] }));
};
const ChainListingCart = ({ chainId, tokens, registerLister, }) => {
    const { listTokens } = useListingCart(tokens, chainId);
    useEffect(() => {
        registerLister(listTokens);
    }, [listTokens, registerLister]);
    return _jsx(_Fragment, {});
};
